module.exports = __webpack_public_path__ + "img/blog-cover-reels-iphone-android.29924458.webp";